import { makeStyles } from '@material-ui/core';
import { Colors } from '../../../utils';

const makeClasses = makeStyles((theme) => ({
  listItemMenu: {
    padding: theme.spacing(1),
  },
  listItemMenuItem: {
    color: Colors.rgb.contentText,
    fontFamily: theme.fontFamily.regular,
    fontSize: theme.fontSize.S,
  },
  listItemActions: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& > button': {
      width: 40,
      padding: 6
    },

    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      right: 0,
      top: 0,
    },
  },
  noDataMessage: {
    fontFamily: theme.fontFamily.semiBold,
    fontSize: theme.fontSize.L,
    color: Colors.rgb.contentTextSoft,
    textAlign: 'center',
    width: '100%',
  },
  menuItemText: {
    minWidth: 0,
    marginTop: 0,
  },
  menuItemIcon: {
    minWidth: 35,
  },
  alert: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
    width: '100%',
    marginBottom: theme.spacing(2),
    boxSizing: 'border-box',
    
    '& > div': {
      display: 'flex',
      gap: theme.spacing(2),
      paddingBottom: theme.spacing(0),
    },
  },
  alertTitle: {
    fontFamily: theme.fontFamily.bold,
  },
  alertIcon: {
    fontSize: 50,
    marginRight: theme.spacing(2),
  },
  alertDanger: {
    borderRadius: '10px',
    border: `1px solid ${Colors.rgb.alertDangerBorder}`,
    color: `${Colors.rgb.alertDangerText} !important`,
  },
  alertWarning: {
    borderRadius: '10px',
    border: `1px solid ${Colors.rgb.alertWarningBorder}`,
    backgroundColor: Colors.rgb.alertWarningBackground,
    color: `${Colors.rgb.alertWarningText} !important`,
  },
  informationAlert: {
    width: '100%',
    boxSizing: 'border-box',
    marginBottom: theme.spacing(2),
    borderRadius: '10px',
    border: `1px solid #8ABCF0`,
    '& > div': {
      display: 'flex',
      gap: theme.spacing(2),
    },
  },
  informationAlertTitle: {
    fontFamily: theme.fontFamily.bold,
    fontSize: theme.fontSize.L,
  },
  informationAlertText: {
    fontSize: theme.fontSize.M,
  },
}));

export default makeClasses;
